module.exports = __webpack_public_path__ + "img/02.f31b6847.png";